





























export default

	props: product: Object

	data: -> loading: false

	computed:

		# Get the primary variant of this product
		primaryVariant: -> @product.variants[0]

		# Vuex shorthand
		cartLines: -> @$store.state.cart.lines

		# Get the cart line if it's in the cart
		productCartLine: -> @cartLines.find (line) =>
			line.variant.id == @primaryVariant.id

		# Is this already in the cart?
		isInCart: -> !!@productCartLine

	methods:

		# Add or remove from cart
		onClick: ->
			return if @loading
			try
				@loading = true
				unless @isInCart
				then await @$store.dispatch 'cart/addItem',
					id: @primaryVariant.id
					quantity: 1
				else await @$store.dispatch 'cart/updateLine',
					id: @productCartLine.id
					quantity: 0
			finally @loading = false


